import { render, staticRenderFns } from "./approvals.vue.js?vue&type=template&id=4d2ccf5f!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./approvals.vue?vue&type=template&id=4d2ccf5f"
import script from "./approvals.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./approvals.vue?vue&type=script&lang=js"
export * from "./approvals.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./approvals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports